// KEEP IN SYNC w/ templates/404.html
import { jsx } from 'panel';
export function template() {
  return jsx("div", {
    sel: '.screen-404'
  }, jsx("div", {
    sel: '.logo-header'
  }, jsx("a", {
    attrs: {
      href: "https://mixpanel.com"
    }
  }, jsx("img", {
    attrs: {
      width: "144",
      height: "48",
      src: "/site_media/images/logo-slate.svg"
    }
  }))), jsx("img", {
    sel: '.error-pie',
    attrs: {
      width: "1120",
      height: "308",
      src: "/site_media/images/error_pages/error_pie.png"
    }
  }), jsx("div", {
    sel: '.not-found-area'
  }, jsx("h1", null, "Page not found"), jsx("h2", null, "We\u2019re thinking this isn\u2019t the page you want..."), jsx("p", null, "There is nothing at this URL. Try checking the address or go to:", jsx("div", null, this.helpers.shouldShowDashboardLink() && jsx("span", null, jsx("a", {
    href: '/report/dashboard'
  }, "Your Dashboard"), ","), jsx("a", {
    href: 'https://help.mixpanel.com'
  }, " Help Center"), ",", jsx("a", {
    href: 'https://community.mixpanel.com/?utm_campaign=mp-links&utm_content=page-not-found&utm_medium=weblink&utm_source=in-product'
  }, " ", "QBQ \u2014 The Mixpanel Community")))));
}